/**
 * Variant cards — show the card's specific variant rating.
 *
 * A review-stars block inside a variant card renders the PRODUCT-level rating
 * (Shopify's block context can't pass the card's variant to a child block).
 * snippets/variant-card.liquid puts the variant's own rating + count on the
 * <variant-card> element (data-reviews-variant-rating / -count, sourced from the
 * per-variant metafields the reviews backfill writes). This re-fills the
 * already-rendered stars and rewrites the (N) count to those values — no
 * network requests. When a variant has no data the attributes are absent and
 * the product-level rating the block rendered is left untouched.
 */
function applyVariantRating(card) {
  const rating = parseFloat(card.dataset.reviewsVariantRating);
  if (!Number.isFinite(rating)) return;

  const wrapper = card.querySelector('.rating-wrapper');
  if (!wrapper) return;

  const stars = wrapper.querySelectorAll('.rating .stars');
  if (stars.length < 2) return; // single-style or no stars — leave as-is

  // Mirror blocks/review.liquid: half star for .3–.7, round up above .7.
  const decimal = rating % 1;
  let decimalRating = 0;
  if (decimal >= 0.3 && decimal <= 0.7) decimalRating = 0.5;
  else if (decimal > 0.7) decimalRating = 1;
  const filled = Math.floor(rating) + Math.ceil(decimalRating);

  stars.forEach((svg, index) => {
    const position = index + 1;
    svg.classList.toggle('filled-star', position <= filled);
    const use = svg.querySelector('use');
    if (use) {
      if (decimalRating === 0.5 && position === filled) use.setAttribute('fill', 'url(#half)');
      else use.removeAttribute('fill');
    }
  });

  const count = card.dataset.reviewsVariantCount;
  if (count != null && count !== '') {
    const countEl = wrapper.querySelector('.rating-count');
    if (countEl) countEl.textContent = `(${count})`;
  }

  const ratingEl = wrapper.querySelector('.rating');
  if (ratingEl) ratingEl.setAttribute('aria-label', String(Math.round(rating * 10) / 10));
}

function initVariantStars() {
  document.querySelectorAll('variant-card[data-reviews-variant-rating]').forEach((card) => {
    applyVariantRating(card);
    // Reveal once set (the CSS hides it until now to avoid the product→variant
    // flash). Always add the class — even if the rewrite no-oped — so the
    // rating can never stay hidden.
    card.classList.add('reviews-variant-ready');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantStars);
} else {
  initVariantStars();
}
